import recruit from './recruit.vue'

export default recruit
